import API from '../API';
import appConfig from 'config/appConfig';
import { IIssueTokensCreateRequest } from 'types';

const COMMUNITY_API_PREFIX = `${appConfig.serviceUrl}/api/communities`;

const communityRequestAPI = {
  issueTokens(values: IIssueTokensCreateRequest): Promise<Array<string>> {
    return API.post<IIssueTokensCreateRequest, Array<string>>(`${COMMUNITY_API_PREFIX}/my/issue-tokens`, values).then(
      (response) => response.data,
    );
  },

  cancelTokenIssue(id: number): Promise<void> {
    return API.delete<void>(`${COMMUNITY_API_PREFIX}/my/issue-tokens/${id}`).then((response) => response.data);
  },
};

export default communityRequestAPI;
